import { createSlice } from '@reduxjs/toolkit';
import { submitTestimonyProgram } from './Utils/TestimonyProgramUtils';

const initialState = {
    name: '',
    isUpdate: false,
    id: '',
    isLoading: false,
};

const addTestimonyProgram = createSlice(
    {
        name: 'addTestimonyProgram',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(submitTestimonyProgram.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(submitTestimonyProgram.fulfilled, (state, action) => {
                    // Handle success state
                    state.isLoading = false;
                    console.log('Sukses:', action.payload);
                })
                .addCase(submitTestimonyProgram.rejected, (state, action) => {
                    // Handle error state
                    state.isLoading = false;
                    console.log(action.error.message, "error action")
                });
        }
    }
);


export const { setField, resetState } = addTestimonyProgram.actions;

export default addTestimonyProgram.reducer;